import {
  DiagnosticsHeader,
  Arrows,
  DiagnosticsScrollableArea,
  DiagnosticsContent,
} from "@/components";
import { useClientHeight } from "@/hooks/useClientHeight";
import { StyledDiagnostics } from "./styled";

const Diagnostics = () => {
  const height = useClientHeight();

  if (!height) {
    return null;
  }

  return (
    <StyledDiagnostics $height={height} id="diagnostics">
      <DiagnosticsHeader />
      <DiagnosticsScrollableArea>
        <DiagnosticsContent />
      </DiagnosticsScrollableArea>
      <Arrows />
    </StyledDiagnostics>
  );
};

export default Diagnostics;